import { Card, Form, Col, Table,ButtonGroup,List,ListItem} from '@deere/ux.uxframe-react'
import {IconButton,Button} from "@deere/fuel-react"
import {React, useState} from 'react'
import { useTranslation } from "react-i18next";
import { useHistory} from 'react-router';
import { SVGIconDelete } from '../SVGIcon';
import { PartPopUp } from '../conflict-mineral/PartPopUp';
import { dateConvert } from '../../utils/utils'
import { getAllPartsRequestedByAssignmentGroup, removeRequestedPartFromAssignment } from '../../services/cm.service';
import { getRequestStatusWhenCampaignClosed } from '../../utils/utils';

export default function CMRTResponsesCard({ loading, userResponses, survey, handleDeleteFn, suppliersInGroup, currentAssignmentId, loadResponses, actionsEnabled, campaign, isAuthMethodOkta, token}) {
    const history = useHistory();
    const { t } = useTranslation();
    const [showParts, setShowParts] = useState(false);

    function review(resp){
        const pathName = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? '/cmext/review' : '/cm/review';
        const previousPath = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? '/cmext' : '/cm';
        history.push({
            pathname: pathName,
            state: {
                previous: previousPath,
                assignmentId: currentAssignmentId,
                responseId: resp.id,
                survey: survey,
                isNonDeere: campaign.isNonDeere
            }
        })
    }

    function closePartWindow(partsDelete) {
        setShowParts(false);
        if(partsDelete){
            loadResponses()
        }
    } 
    const popUpPartsLink = (e) => {
            e.preventDefault();
            setShowParts(true);
    }

    return (
        <>
        <Card>
            <Card.Body>
                <Card.Title className='pb-3 font-weight-bold'>
                    4. {t('cm_lbl_responses_title')}
                </Card.Title>
                <Form.Label>{t('cm_lbl_responses_subtitle')}</Form.Label>
                <Form.Row className="d-block mb-4">
                    <Col>
                        <List variant="uxf" >
                            {
                                suppliersInGroup && suppliersInGroup.map( ( supplierAssignment, indx ) => 
                                    <ListItem variant="nav" key={indx}>
                                        {supplierAssignment.supplierNumber} - {supplierAssignment.supplierName} 
                                        (Request {supplierAssignment.id} Status: {supplierAssignment && campaign ? getRequestStatusWhenCampaignClosed(supplierAssignment.status, campaign.status) : ""})
                                    </ListItem>
                                )
                            }
                        </List>                        
                    </Col>                    
                </Form.Row>
                    <br/>
                <Form.Row className="d-block mb-4">
                    {userResponses && userResponses.length > 0?<Table  responsive size="sm">
                        <thead>
                            <tr>
                                <th scope="col" className="text-right">{t('cm_lbl_upload_collumn_response_number')}</th>
                                <th scope="col" className="text-left">{t('cm_lbl_upload_collumn_status')}</th>
                                <th scope="col" className="text-left">{t('cm_lbl_upload_collumn_file')}</th>
                                <th scope="col" className="text-right">{t('cm_lbl_upload_collumn_parts_req')}</th>
                                <th scope="col" className="text-right">{t('cm_lbl_upload_collumn_nof')}</th>  
                                <th scope="col" className="text-center">{t('cm_lbl_upload_collumn_tmstmp')}</th>
                                <th scope="col" className="text-center"></th>
                                <th scope="col" className="text-center"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                    userResponses.map((resp, index) =>
                                       ( <tr id={index} key={index}>
                                            <td className="text-right">                                            
                                                <ButtonGroup aria-label="Basic example">
                                                    <Button className='mr-2' variant="text-inline" onClick={e => review(resp)}>{resp.id}</Button>
                                                </ButtonGroup>
                                            </td>
                                            <td className="text-left">{resp.status? resp.status : ''}</td>
                                            <td className="text-left">{resp.fileName}</td>
                                            <td className="text-right">
                                                <a href='#' onClick={e => {popUpPartsLink(e);}} >{resp.totalRequestedParts}</a>
                                            </td>
                                            <td className="text-right">{resp.numberOfParts}</td>
                                            <td className="text-right">{dateConvert(resp.createdTs)}</td>
                                            <td className="text-center">
                                                {!resp.status?
                                                    <ButtonGroup aria-label="Basic example">
                                                        <Button disabled={loading} className='mr-2' variant="primary" onClick={e => review(resp)}>{t('btn_review')}</Button>
                                                    </ButtonGroup>
                                                    : ''
                                                }
                                            </td>
                                            <td className="text-center">
                                            <div style={{ textAlign: "left" }}>
                                                {actionsEnabled && <IconButton disabled={loading} aria-label="delete" onClick={e => handleDeleteFn(resp.id)}>
                                                                    <SVGIconDelete />
                                                                </IconButton>}
                                            </div>
                                        </td>
                                    </tr>)
                                )
                            }
                        </tbody>

                        </Table>:<></>
                    }
                </Form.Row>
            </Card.Body>
        </Card>
        {
            showParts && userResponses && userResponses.length > 0? <PartPopUp show={showParts} handleClose={closePartWindow} requestNumber={currentAssignmentId} partFunc={getAllPartsRequestedByAssignmentGroup} partDeleteFunc={removeRequestedPartFromAssignment} campaign={campaign} survey={survey} isAuthMethodOkta={isAuthMethodOkta} token={token}></PartPopUp>:null
        }
        </>);
}
